
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/politica-de-privacidade",
      function () {
        return require("private-next-pages/politica-de-privacidade/index.page.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/politica-de-privacidade"])
      });
    }
  